import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, vShow as _vShow, vModelRadio as _vModelRadio, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20_mobile px-4" }
const _hoisted_3 = { class: "widget px-7 py-7" }
const _hoisted_4 = {
  key: 0,
  class: "stepper-navigation mb-6"
}
const _hoisted_5 = { class: "stepper-steps" }
const _hoisted_6 = { class: "s10_mobile container-full-2" }
const _hoisted_7 = { class: "form-field-floating lg reactive active my-5" }
const _hoisted_8 = {
  key: 0,
  class: "text-red"
}
const _hoisted_9 = { class: "form-field-floating lg reactive active my-5" }
const _hoisted_10 = {
  key: 1,
  class: "text-red"
}
const _hoisted_11 = { class: "form-field-floating active my-4" }
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 2,
  class: "text-red"
}
const _hoisted_14 = { class: "form-field-floating lg reactive my-5" }
const _hoisted_15 = {
  key: 3,
  class: "text-red"
}
const _hoisted_16 = { class: "form-field-split active my-5" }
const _hoisted_17 = { class: "form-field-floating lg reactive half" }
const _hoisted_18 = {
  key: 4,
  class: "text-red"
}
const _hoisted_19 = {
  key: 5,
  class: "text-red"
}
const _hoisted_20 = { class: "form-field-floating lg reactive my-5" }
const _hoisted_21 = {
  key: 6,
  class: "text-red"
}
const _hoisted_22 = { class: "s10_mobile container-full-2" }
const _hoisted_23 = { class: "grid2 grid-row-gap-0" }
const _hoisted_24 = ["for"]
const _hoisted_25 = { class: "card-check-text" }
const _hoisted_26 = ["id", "value"]
const _hoisted_27 = { class: "font-semibold mt-1 mb-2 align-right" }
const _hoisted_28 = {
  key: 0,
  class: "text-red"
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "s10_mobile container-full-2" }
const _hoisted_31 = { class: "my-5" }
const _hoisted_32 = { class: "grid2 grid-row-gap-0" }
const _hoisted_33 = { class: "card-check lg single" }
const _hoisted_34 = {
  class: "form-check-label",
  for: "gerant_type_new"
}
const _hoisted_35 = { class: "card-check-text" }
const _hoisted_36 = { class: "card-check lg single" }
const _hoisted_37 = {
  class: "form-check-label",
  for: "gerant_type_existing"
}
const _hoisted_38 = { class: "card-check-text" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "form-field-floating active my-5" }
const _hoisted_41 = ["value"]
const _hoisted_42 = {
  key: 0,
  class: "text-red"
}
const _hoisted_43 = {
  key: 1,
  class: "text-grey-500 text-sm mt-2"
}
const _hoisted_44 = { class: "s10_mobile container-full-2" }
const _hoisted_45 = {
  key: 0,
  class: "text-red"
}
const _hoisted_46 = { class: "flex gap-2" }

import { onMounted, reactive, ref, watch } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';
    import moment from 'moment';
    import OnboardingPersonalInfosForm from '@/views/collectivites/onboarding/OnboardingPersonalInfosForm.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesFormView',
  setup(__props) {

    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const currentStep = ref(1);
    const startupFormDatas = reactive({
        pays: [] as any[],
        users: [] as any[]
    });
    const gerantType = ref<'new' | 'existing'>('new'); // Type de gérant : 'new' ou 'existing'
    const gerantFormRef = ref<InstanceType<typeof OnboardingPersonalInfosForm> | null>(null);
    const formData = reactive({
        id: null as number | null,
        nom: "",
        rccm: "",
        adresse: "",
        telephone: "",
        email: "",
        date_creation: "",
        pays_id: null as number | null,
        secteurs: [] as string[],
        gerant_id: null as number | null // ID de l'utilisateur existant à associer
    });
    const errors = reactive({
        nom: "",
        rccm: "",
        adresse: "",
        telephone: "",
        email: "",
        date_creation: "",
        pays_id: "",
        secteurs: "",
        gerant_id: ""
    });
    const secteurs: any[] = [
      { id: 'finance', value: 'Finance', label: 'Finance' },
      { id: 'informatique', value: 'Informatique', label: 'Informatique' },
      { id: 'agriculture', value: 'Agriculture', label: 'Agriculture' },
      { id: 'education', value: 'Éducation', label: 'Éducation' },
      { id: 'sante', value: 'Santé', label: 'Santé' },
      { id: 'transport', value: 'Transport', label: 'Transport' },
      { id: 'construction', value: 'Construction', label: 'Construction' },
      { id: 'commerce', value: 'Commerce', label: 'Commerce' },
      { id: 'industrie', value: 'Industrie', label: 'Industrie' },
      { id: 'autre', value: 'Autre', label: 'Autre' }
    ]

    onMounted(() => {
        const form_datas = route.meta.form_datas as { collectivite: any, startupFormDatas: any };
        Object.assign(startupFormDatas, form_datas.startupFormDatas);
        if (form_datas.collectivite) {
            const collectivite = form_datas.collectivite as any;
            if (collectivite.date_creation) {
                const date_creation = moment(collectivite.date_creation);
                collectivite.date_creation = date_creation.isValid() ? date_creation.format('YYYY-MM-DD') : '';
            }
            Object.assign(formData, collectivite);
        }
    });

    function validateStep1() {
        let isValid = true;
        errors.nom = '';
        if (!formData.nom) {
            errors.nom = "Le nom est requis";
            isValid = false;
        }

        errors.pays_id = '';
        if (!formData.pays_id || formData.pays_id <= 0) {
            errors.pays_id = "Le pays est requis";
            isValid = false;
        }

        errors.rccm = '';
        if (!formData.rccm) {
            errors.rccm = "Le RCCM est requis";
            isValid = false;
        }

        errors.adresse = '';
        if (!formData.adresse) {
            errors.adresse = "L'adresse est requise";
            isValid = false;
        }

        errors.telephone = '';
        if (!formData.telephone) {
            errors.telephone = "Le téléphone est requis";
            isValid = false;
        }

        errors.email = '';
        if (!formData.email) {
            errors.email = "L'email est requis";
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Le format de l'email est invalide";
            isValid = false;
        }

        errors.secteurs = '';
        if (!formData.secteurs || formData.secteurs.length === 0) {
            errors.secteurs = "Au moins un secteur est requis";
            isValid = false;
        }

        errors.date_creation = '';
        if (!formData.date_creation) {
            errors.date_creation = "La date de création est requise";
            isValid = false;
        }

        return isValid;
    }

    function validateStep2() {
        let isValid = true;
        errors.gerant_id = '';

        if (gerantType.value === 'existing') {
            // Si on sélectionne un utilisateur existant, vérifier que gerant_id est défini
            if (!formData.gerant_id) {
                errors.gerant_id = "Veuillez sélectionner un utilisateur existant";
                isValid = false;
            }
        } else {
            // Si on crée un nouveau gérant, utiliser la validation du composant
            if (gerantFormRef.value) {
                isValid = gerantFormRef.value.validate();
            }
        }

        return isValid;
    }

    function validate() {
        if (currentStep.value === 1) {
            return validateStep1();
        } else if (currentStep.value === 2) {
            return validateStep2();
        }
        return true;
    }

    function goToNextStep() {
        if (currentStep.value === 1) {
            if (validateStep1()) {
                currentStep.value = 2;
                errorMessage.value = '';
            }
        }
    }

    function goToPreviousStep() {
        if (currentStep.value === 2) {
            currentStep.value = 1;
            errorMessage.value = '';
        }
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            // Utiliser FormData pour supporter l'upload de photo
            const formToUpload = new FormData();

            if (formData.id) {
                formToUpload.append('id', String(formData.id));
            }
            formToUpload.append('nom', formData.nom);
            formToUpload.append('rccm', formData.rccm);
            formToUpload.append('adresse', formData.adresse);
            formToUpload.append('telephone', formData.telephone);
            formToUpload.append('email', formData.email);
            formToUpload.append('pays_id', String(formData.pays_id));
            formToUpload.append('date_creation', formData.date_creation);
            formData.secteurs.forEach((secteur, index) => {
                formToUpload.append(`secteurs[${index}]`, secteur);
            });

            // En mode création (stepper), ajouter les données du gérant
            if (!formData.id && currentStep.value === 2) {
                if (gerantType.value === 'existing' && formData.gerant_id) {
                    // Associer un utilisateur existant
                    formToUpload.append('gerant_id', String(formData.gerant_id));
                } else if (gerantType.value === 'new' && gerantFormRef.value) {
                    // Créer un nouveau gérant avec les données du formulaire
                    const gerantData = gerantFormRef.value.formData;
                    formToUpload.append('gerant[nom]', gerantData.nom || '');
                    formToUpload.append('gerant[prenom]', gerantData.prenom || '');
                    formToUpload.append('gerant[telephone]', gerantData.telephone || '');
                    formToUpload.append('gerant[email]', gerantData.email || '');
                    if (gerantData.date_naissance) {
                        formToUpload.append('gerant[date_naissance]', gerantData.date_naissance);
                    }
                    formToUpload.append('gerant[age]', String(gerantData.age || 0));
                    if (gerantData.date_engagement) {
                        formToUpload.append('gerant[date_engagement]', gerantData.date_engagement);
                    }
                    formToUpload.append('gerant[anciennete]', String(gerantData.anciennete || 0));
                    formToUpload.append('gerant[salaire]', gerantData.salaire || '');
                    formToUpload.append('gerant[quotite_cessible_pourcent]', gerantData.quotite_cessible_pourcent || '');
                    formToUpload.append('gerant[quotite_cessible_montant]', gerantData.quotite_cessible_montant || '');
                }
            }

            await axios.post(`/backoffice/collectivites/save`, formToUpload, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            router.push('/app/collectivites/list');
        } catch(error: any) {
            errorMessage.value = error.response?.data?.message || error.message || "Une erreur est survenue";
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_phone_input = _resolveComponent("custom-phone-input")!
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[39] || (_cache[39] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[36] || (_cache[36] = _createElementVNode("h4", { class: "font-semibold mb-5" }, [
          _createTextVNode("Collectivités / Edition "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        (!formData.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(["stepper-step", { active: currentStep.value === 1, completed: currentStep.value > 1 }])
                }, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("div", { class: "stepper-step-number" }, "1", -1),
                  _createElementVNode("div", { class: "stepper-step-label" }, "Collectivité", -1)
                ]))], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["stepper-line", { completed: currentStep.value > 1 }])
                }, null, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["stepper-step", { active: currentStep.value === 2 }])
                }, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("div", { class: "stepper-step-number" }, "2", -1),
                  _createElementVNode("div", { class: "stepper-step-label" }, "Gérant", -1)
                ]))], 2)
              ])
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-info-collectivite.svg",
                class: "size-l",
                alt: ""
              }),
              _createTextVNode(" Informations ")
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                name: "nom",
                id: "nom",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.nom) = $event)),
                placeholder: ""
              }, null, 512), [
                [_vModelText, formData.nom]
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("label", { for: "nom" }, [
                _createTextVNode("Désignation de la collectivité "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            (!!errors['nom'])
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(errors['nom']), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                name: "rccm",
                id: "rccm",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.rccm) = $event)),
                placeholder: ""
              }, null, 512), [
                [_vModelText, formData.rccm]
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("label", { for: "rccm" }, [
                _createTextVNode("Numéro du registre de commerce "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            (!!errors['rccm'])
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(errors['rccm']), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("select", {
                class: "form-input-select",
                name: "pays_id",
                id: "pays_id",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.pays_id) = $event))
              }, [
                _cache[18] || (_cache[18] = _createElementVNode("option", {
                  value: null,
                  selected: ""
                }, "Sélectionnez un pays", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupFormDatas.pays, (pays, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: pays.id,
                    key: 'pays_' + index
                  }, _toDisplayString(pays.nom), 9, _hoisted_12))
                }), 128))
              ], 512), [
                [_vModelSelect, formData.pays_id]
              ]),
              _cache[19] || (_cache[19] = _createElementVNode("label", { for: "pays_id" }, [
                _createTextVNode("Pays "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            (!!errors['pays_id'])
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(errors['pays_id']), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                name: "adresse",
                id: "adresse",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.adresse) = $event)),
                placeholder: ""
              }, null, 512), [
                [_vModelText, formData.adresse]
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("label", { for: "adresse" }, [
                _createTextVNode("Adresse de l'entreprise "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            (!!errors['adresse'])
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(errors['adresse']), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_custom_phone_input, {
                modelValue: formData.telephone,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.telephone) = $event)),
                id: "telephone",
                classesNames: "half"
              }, null, 8, ["modelValue"]),
              _cache[22] || (_cache[22] = _createElementVNode("hr", { class: "hr" }, null, -1)),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-input",
                  name: "email",
                  id: "email",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.email) = $event)),
                  placeholder: ""
                }, null, 512), [
                  [_vModelText, formData.email]
                ]),
                _cache[21] || (_cache[21] = _createElementVNode("label", { for: "email" }, [
                  _createTextVNode("Adresse Email "),
                  _createElementVNode("b", { class: "color-danger" }, "*")
                ], -1))
              ])
            ]),
            (!!errors['telephone'])
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(errors['telephone']), 1))
              : _createCommentVNode("", true),
            (!!errors['email'])
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(errors['email']), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-input",
                name: "date_creation",
                id: "date_creation",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.date_creation) = $event)),
                placeholder: ""
              }, null, 512), [
                [_vModelText, formData.date_creation]
              ]),
              _cache[23] || (_cache[23] = _createElementVNode("label", { for: "date_creation" }, "Date de création", -1))
            ]),
            (!!errors['date_creation'])
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(errors['date_creation']), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[25] || (_cache[25] = _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-secteur-activite.svg",
                class: "size-l",
                alt: ""
              }),
              _createTextVNode(" Secteur d'activité ")
            ], -1)),
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(secteurs, (secteur) => {
                return _createElementVNode("div", {
                  key: secteur.id,
                  class: "card-check lg single"
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: `secteur_${secteur.id}`
                  }, [
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input left",
                        type: "checkbox",
                        name: "secteur[]",
                        id: `secteur_${secteur.id}`,
                        value: secteur.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.secteurs) = $event))
                      }, null, 8, _hoisted_26), [
                        [_vModelCheckbox, formData.secteurs]
                      ]),
                      _createElementVNode("h6", _hoisted_27, _toDisplayString(secteur.label), 1)
                    ])
                  ], 8, _hoisted_24)
                ])
              }), 64))
            ]),
            (!!errors['secteurs'])
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(errors['secteurs']), 1))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, !formData.id ? currentStep.value === 1 : true]
        ]),
        (!formData.id)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[31] || (_cache[31] = _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-info-perso.svg",
                    class: "size-l",
                    alt: ""
                  }),
                  _createTextVNode(" Membre Gérant ")
                ], -1)),
                _createElementVNode("div", _hoisted_31, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", { class: "font-medium mb-3 block" }, [
                    _createTextVNode("Type de gérant "),
                    _createElementVNode("b", { class: "color-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("label", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input left",
                            type: "radio",
                            name: "gerant_type",
                            id: "gerant_type_new",
                            value: "new",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((gerantType).value = $event))
                          }, null, 512), [
                            [_vModelRadio, gerantType.value]
                          ]),
                          _cache[26] || (_cache[26] = _createElementVNode("h6", { class: "font-semibold mt-1 mb-2 align-right" }, "Créer un nouveau gérant", -1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input left",
                            type: "radio",
                            name: "gerant_type",
                            id: "gerant_type_existing",
                            value: "existing",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((gerantType).value = $event))
                          }, null, 512), [
                            [_vModelRadio, gerantType.value]
                          ]),
                          _cache[27] || (_cache[27] = _createElementVNode("h6", { class: "font-semibold mt-1 mb-2 align-right" }, "Utiliser un utilisateur existant", -1))
                        ])
                      ])
                    ])
                  ])
                ]),
                (gerantType.value === 'existing')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _withDirectives(_createElementVNode("select", {
                          class: "form-input-select",
                          name: "gerant_id",
                          id: "gerant_id",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.gerant_id) = $event))
                        }, [
                          _cache[29] || (_cache[29] = _createElementVNode("option", {
                            value: null,
                            selected: ""
                          }, "Sélectionnez un utilisateur", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupFormDatas.users, (user, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: user.id,
                              key: 'user_' + index
                            }, _toDisplayString(user.fullname) + " - " + _toDisplayString(user.email) + " " + _toDisplayString(user.fonction ? '(' + user.fonction + ')' : ''), 9, _hoisted_41))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, formData.gerant_id]
                        ]),
                        _cache[30] || (_cache[30] = _createElementVNode("label", { for: "gerant_id" }, [
                          _createTextVNode("Utilisateur existant "),
                          _createElementVNode("b", { class: "color-danger" }, "*")
                        ], -1))
                      ]),
                      (!!errors.gerant_id)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(errors.gerant_id), 1))
                        : _createCommentVNode("", true),
                      (startupFormDatas.users.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_43, " Aucun utilisateur disponible. Créez d'abord un utilisateur ou choisissez \"Créer un nouveau gérant\". "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (gerantType.value === 'new')
                ? (_openBlock(), _createBlock(OnboardingPersonalInfosForm, {
                    key: 0,
                    ref_key: "gerantFormRef",
                    ref: gerantFormRef,
                    collectivites: [],
                    "hide-collectivite-field": true,
                    "hide-submit-button": true
                  }, null, 512))
                : _createCommentVNode("", true)
            ], 512)), [
              [_vShow, currentStep.value === 2]
            ])
          : _createCommentVNode("", true),
        _cache[37] || (_cache[37] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
        _createElementVNode("div", _hoisted_44, [
          (!!errorMessage.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true),
          _cache[35] || (_cache[35] = _createElementVNode("p", { class: "text-xs text-grey-500 mb-5" }, [
            _createElementVNode("b", { class: "color-danger text-xs" }, "*"),
            _createTextVNode(" Les champs marqués d'un astérisque sont obligatoires")
          ], -1)),
          _createElementVNode("div", _hoisted_46, [
            (!formData.id && currentStep.value === 2)
              ? (_openBlock(), _createBlock(_component_custom_button, {
                  key: 0,
                  id: "btn-prev",
                  type: "button",
                  classesList: 'btn lg',
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (goToPreviousStep()))
                }, {
                  default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                    _createElementVNode("span", null, "Précédent", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!formData.id && currentStep.value === 1)
              ? (_openBlock(), _createBlock(_component_custom_button, {
                  key: 1,
                  id: "btn-next",
                  type: "button",
                  classesList: 'btn lg w-100',
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (goToNextStep()))
                }, {
                  default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                    _createElementVNode("span", null, "Suivant", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (formData.id || (!formData.id && currentStep.value === 2))
              ? (_openBlock(), _createBlock(_component_custom_button, {
                  key: 2,
                  id: "btn-submit",
                  type: "button",
                  classesList: 'btn lg w-100',
                  loading: loading.value,
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (onSubmit()))
                }, {
                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                    _createElementVNode("img", {
                      src: "/icons/icon-enregistrer.svg",
                      class: "btn-icon",
                      alt: ""
                    }, null, -1),
                    _createElementVNode("span", null, "Enregistrer", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[38] || (_cache[38] = _createElementVNode("div", { class: "clear-both h-25" }, null, -1))
      ])
    ])
  ]))
}
}

})